// extracted by mini-css-extract-plugin
module.exports = {"modal":"BV","modalContent":"CV","modalOverlay":"DV","copy":"EV","modalBtnContainer":"FV","btnStay":"GV","disabled":"HV","btnContinue":"IV"};